import { render, staticRenderFns } from "./DoRight.vue?vue&type=template&id=633671f1&scoped=true"
import script from "./DoRight.vue?vue&type=script&lang=js"
export * from "./DoRight.vue?vue&type=script&lang=js"
import style0 from "./DoRight.vue?vue&type=style&index=0&id=633671f1&prod&lang=scss&scoped=true"
import style1 from "./DoRight.vue?vue&type=style&index=1&id=633671f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633671f1",
  null
  
)

export default component.exports